import React from 'react';
import { CellTemplateProps } from '../../../components/KendoDataGrid/KendoDataGrid.types';
import { FB } from '../..';
import { useSerialNumbersOptions } from '../utils';
import { Autocomplete } from '../../../components/forms/fields-next';
import { translate } from '../../../../common/intl';
import { SerialNumber } from '../../FBSerials/types';
import { DEVIATION_SERIAL_NUMBERS_KEY } from '../types';

const GroupsCellTemplate: React.FC<CellTemplateProps<{}>> = ({
  field,
  dataItem,
  ...props
}) => {
  const { formState, workspaceState } = FB.useStores();
  const lhrId = Object.keys(dataItem)[0] as any;
  const serialNumberIds = dataItem[lhrId]?.serialNumbers ?? [];
  const { serialNumbersOptions } = useSerialNumbersOptions(lhrId);
  const values = serialNumbersOptions.filter(item => serialNumberIds.includes(item.id));

  const handleChange = (_, option: SerialNumber[]) => {
    const fieldData = formState?.getFieldValue(DEVIATION_SERIAL_NUMBERS_KEY);
    const updatedIds = option.map(item => item.id);
    const updatedFieldData = fieldData.map(item => {
    if (!item[lhrId]) {
      return item;
    }

    return {
      ...item,
      [lhrId]: {
        ...item[lhrId],
        serialNumbers: updatedIds,
      },
    };
    });
    formState?.setFieldValue(DEVIATION_SERIAL_NUMBERS_KEY, updatedFieldData);
    workspaceState?.saveDocRev(formState?.getValues());
  };

  return (
    <Autocomplete
        value={values}
        key={lhrId}
        options={serialNumbersOptions ?? []}
        multiple
        blurOnSelect
        disableOpenOnFocus
        placeholder={translate('common.select')}
        size="small"
        getOptionLabel={(opt) => opt.serialNumber}
        onChange={handleChange} />
  );
};

export default GroupsCellTemplate;
